import _ from 'lodash';
const initialState ={
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case "MANUAL_ASSIGN_ERROR":
        return Object.assign({}, state, {
          showerror: action.showerror,
          errmessage: action.errmessage
      })
      case "MANUAL_ASSIGN_CLOSE":
        return Object.assign({}, state, {
          showerror: action.showerror
      }) 
      case "AGENTS_NAME":
        let obj = action.agentsName
        let data = _.map(obj, (val) => { return {'employeeId':val.employeeId} })
        console.log('data', data)
        return Object.assign({}, state, {
          agentsName: data
      }) 
   
     default:
      return state
    }
   }
  
   